module.exports = __webpack_public_path__ + "39b34cbe19246cfdc51323c420b97668.gif";